


























































































































































































































































































































































































































import Vue from "vue";
// @ts-ignore
import ship_select from "@/static/ship_select.png";
// @ts-ignore
import ship_icon from "@/static/ship.png";
// @ts-ignore
import store_select from "@/static/store_select.png";
// @ts-ignore
import store_icon from "@/static/store.png";
// @ts-ignore
import gate_select from "@/static/gate_select.png";
// @ts-ignore
import gate_icon from "@/static/gate.png";

import VueAMap from "vue-amap";

import mmap from "./components/mmap.vue";
import TopHead from "./components/topHead.vue";
import LeftList from "./components/leftList.vue";
import {
  delStore,
  getGate,
  getShip,
  getStore,
  goods,
  LeftMenu,
  point,
  delivery,
  customAddr,
  customList,
} from "@/api/user";

import { Loading } from "element-ui";
import { getUserInfo } from "@/api/users";
import { shipAuth, User } from "@/api/model/user";
import AddCustom from "./components/addCustom.vue";
export default Vue.extend({
  components: { mmap, TopHead, LeftList, AddCustom },
  data() {
    return {
      // 选中的点的序号
      select: -1,
      icon_select: [
        ship_select,
        store_select,
        gate_select,
        ship_select,
        ship_select,
        ship_select,
      ],
      icon_def: [
        ship_icon,
        store_icon,
        gate_icon,
        ship_icon,
        ship_icon,
        ship_icon,
      ],
      leftMenu: <LeftMenu[]>[],
      // 船舶列表
      shippings: <point[]>[],
      // 地图显示类型 0：船舶，1仓库，2船闸
      types: 0,
      keywords: "",
      // 显示添加框
      showEdit: false,
      editData: <any>{},
      // 地图选点
      marker: {
        lnglat: <number[]>[],
        address: "",
      },
      delivery: <goods[]>[], //发货查询结果
      editPoint: <point>{},
      showHistory: false,
      historySearch: {
        code: "",
        timeRange: <string[]>[],
      },
      user: <User>{},
      auth: <any[]>[],
    };
  },
  created() {
    this.auth = shipAuth;
    getUserInfo().then((res) => {
      console.log(res);
      this.user = res;
    });
    this.getShip();
  },
  computed: {
    isShipList: function (): boolean {
      console.log(this.types, [0, 3, 4, 5].indexOf(this.types));
      if ([0, 3, 4, 5].indexOf(this.types) != -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  // watch: {
  //   types: function () {
  //     this.select = -1;
  //     switch (this.types) {
  //       case 0:
  //       case 4:
  //       case 5:
  //         this.getShip();
  //         break;
  //       case 1:
  //         this.getStore();
  //         break;
  //       case 2:
  //         this.getGates();
  //         break;
  //       case 3:
  //         this.showHistory = true;
  //         break;
  //     }
  //   },
  // },
  methods: {
    selectPoint(index: number) {
      this.showEdit = false;
      this.select = index;
      this.marker = {
        lnglat: <number[]>[],
        address: "",
      };
      this.showEdit = this.leftMenu[index].showEdit || false;
      this.editData = this.leftMenu[index];
    },
    search(keywords: string) {
      console.log(keywords);
      this.keywords = keywords;
    },

    setType(types: number) {
      this.types = types;
      this.showEdit = false;
      this.select = -1;
      switch (this.types) {
        case 0:
        case 4:
        case 5:
          this.getShip();
          break;
        case 1:
          this.getStore();
          break;
        case 2:
          this.getGates();
          break;
        case 3:
          this.showHistory = true;
          break;
      }
    },
    showFoot(index: number) {
      if (index > -1) {
        this.editPoint = this.shippings[index];
      } else {
        this.editPoint = <point>{};
      }
      this.showEdit = true;
    },
    closeFoot() {
      this.showEdit = false;
      this.setType(this.types)
    },
    delList(index: number) {
      var loading = Loading.service({});
      delStore(index)
        .then((res) => {
          this.shippings.splice(index, 1);
        })
        .finally(() => {
          loading.close();
        });
    },

    getShip() {
      getShip(this.keywords, this.types).then((res) => {
        res.list.map(
          (v) =>
            (v.title =
              v.status == 1 ? v.title + "(停运)" : v.title + "(行驶中)")
        );
        this.leftMenu = res.list;
      });
    },
    getStore() {
      getStore()
        .then((res) => {
          this.leftMenu = res.list;
        })
        .catch((e) => {});
    },
    async getGates(){
      this.leftMenu=[]
      await getGate()
        .then((res) => {
          //@ts-ignore
          this.leftMenu = res.list;
        });
        customList().then(res=>{
          console.log(res.list)
          res.list.map(v=>{
            v.showEdit=true;
            this.leftMenu.push(v)
          })
        })
    },
    getDelivery() {
      if (
        this.historySearch.code == "" ||
        this.historySearch.timeRange.length != 2
      ) {
        this.$message.error("船号必填");
        return;
      }
      var loading = Loading.service({});
      delivery(
        this.historySearch.code,
        this.historySearch.timeRange[0],
        this.historySearch.timeRange[1]
      )
        .then((res) => {
          this.delivery = res;
        })
        .finally(() => {
          loading.close();
        });
    },
    clickMap(e: any) {
      console.log("click", e);
      this.showEdit = false;
      var that = this;
      // @ts-ignore
      AMap.plugin("AMap.Geocoder", () => {
        // @ts-ignore
        var geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all",
        });
        geocoder.getAddress(
          [e.lnglat.lng, e.lnglat.lat],
          function (status: string, result: any) {
            console.log([e.lnglat.lng, e.lnglat.lat], status, result);
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                that.marker = {
                  lnglat: [e.lnglat.lng, e.lnglat.lat],
                  address: result.regeocode.formattedAddress,
                };
                that.showEdit = true;
                that.editData = <customAddr>{
                  uid: "0",
                  title: "",
                  address: result.regeocode.formattedAddress,
                  desc: "",
                  lat: e.lnglat.lat,
                  lng: e.lnglat.lng,
                  status:1
                };
              }
            }
          }
        );
      });
    },
  },
});
